<template>
  <div>
    <el-form class="search_form" size="mini" :inline="true">
      <!--搜索框-->
      <!--    <el-col :span="3">
          <el-form-item>
             <el-select placeholder="运营商" clearable v-model="operatorId">
               <el-option
                 v-for="item in operatorHisList"
                 :key="item.value"
                 :label="item.label"
                 :value="item.value"
               ></el-option>
             </el-select>
           </el-form-item>
         </el-col>-->
      <el-col :span="3">
        <el-form-item>
          <el-input
            v-model="ruleName"
            placeholder="费率名称"
            clearable
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <el-form-item>
          <el-input v-model="id" placeholder="费率id" clearable></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <el-form-item>
          <el-select placeholder="记录类型" clearable v-model="operationType">
            <el-option
              v-for="item in operationTypeList"
              :key="item.value"
              :label="item.message"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
<!--      <el-col :span="1.5">
        <el-form-item>
          <el-button size="mini" type="primary" @click="reset">清空</el-button>
        </el-form-item>
      </el-col>-->
      <el-col :span="1.5">
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="check"
            >查询
          </el-button>
        </el-form-item>
      </el-col>
    </el-form>
    <el-table
      :data="list"
      stripe
      style="width: 100%"
      ref="list"
      border
      v-loading="Loading"
    >
      <af-table-column prop="id" label="费率记录ID"></af-table-column>
      <af-table-column prop="backupRuleId" label="费率ID"></af-table-column>
      <af-table-column prop="ruleName" label="费率名称"></af-table-column>
      <af-table-column prop="operatorName" label="所属运营商"></af-table-column>
      <af-table-column prop="amountTop" label="上限(元)">
        <template #default="{ row }">
          {{ row.haveAmountTopCode === "Y" ? row.amountTop : "无上限" }}
        </template>
      </af-table-column>
      <af-table-column
        prop="reduceTime"
        label="减免时长(分钟)"
      ></af-table-column>
      <af-table-column prop="operatorName" label="费率价格">
        <template #default="{ row }">
          <div v-for="(item, index) in row.timeSlotList" :key="index">
            {{ item.showName }}
          </div>
        </template>
      </af-table-column>
      <af-table-column prop="operatorName" label="操作类型">
        <template #default="{ row }">
          {{ row.operationType.message }}
        </template>
      </af-table-column>
      <af-table-column prop="stationId" label="场站id"> </af-table-column>
      <af-table-column prop="createUser" label="操作人"></af-table-column>
      <af-table-column prop="createDate" label="最后更新时间"></af-table-column>
      <af-table-column label="操作" width="120px" fixed="right">
        <template #default="{ row }">
          <el-button
            size="mini"
            v-if="checkPermission(['bee:res:rate:takeUpPileRecord:page'])"
            @click="addPOF(row.id)"
            >查看
          </el-button>
        </template>
      </af-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      style="margin-top: 15px"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      background
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <addPOF
      ref="forms"
      :operatorHisList="operatorHisList"
      :showDialog.sync="showDialog"
      :params.sync="params"
    ></addPOF>
  </div>
</template>

<script>
import addPOF from "./addPOF.vue";
import OccupancyFeeApi from "../../../api/OccupancyFeeApi";
export default {
  name: "ccupyPileArchiving",
  components: {
    addPOF,
  },
  data() {
    return {
      pageSize: 10, // 页容量
      currentPage: 1, // 页码
      total: 1, // 总数据量
      operatorId: "", // 运营商id
      ruleName: "", // 费率名称
      id: "", // 费率id
      operationType: "", // 记录类型
      operationTypeList: [], // 记录类型
      showDialog: false, // 新增费率弹窗
      list: [], // 列表数据
      Loading: false, // 加载
      params: "",
    };
  },
  props: {
    operatorHisList: {
      type: Array,
      required: true,
    },
  },
  created() {
    this.operatorId = sessionStorage.getItem('operatorId');
    // 调用获取列表数据
    this.getBillingRulesRecord();
    // 获取操作枚举
    this.recordOperationTypeEnum();
  },




  watch: {
    '$store.state.operatorId': {
      handler: function (newVal, oldVal) {
        this.operatorId = sessionStorage.getItem('operatorId');
        // 调用获取列表数据
        this.getBillingRulesRecord();
      },
      deep: true
    }
  },

  methods: {
    // 获取操作枚举
    recordOperationTypeEnum() {
      OccupancyFeeApi.recordOperationTypeEnum().then((res) => {
        this.operationTypeList = res.data;
      });
    },
    // 获取列表数据
    getBillingRulesRecord() {
      this.Loading = true;
      let params = {
        pageSize: this.pageSize,
        currentPage: this.currentPage,
        t: {
          id: this.id,
          operatorId: this.operatorId,
          ruleName: this.ruleName,
          operationType: this.operationType,
        },
      };
      // console.log(params, "参数");
      OccupancyFeeApi.getBillingRulesRecord(params).then((res) => {
        console.log(res.data, "fenfenfnenfenfnenfnen");
        this.total = res.data.total;
        this.list = res.data.records;
        this.Loading = false;
      });
    },
    // 打开弹窗
    addPOF(e) {
      let param = {
        id: e,
        titleName: "查看",
      };
      this.params = JSON.stringify(param);
      this.showDialog = true;
    },
    // 清空搜索数据
    reset() {
      this.id = "";
      this.operatorId = "";
      this.ruleName = "";
      this.operationType = "";
    },
    // 查询数据
    check() {
      this.pageSize = 10;
      this.currentPage = 1;
      this.getBillingRulesRecord();
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getBillingRulesRecord();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getBillingRulesRecord();
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/rateManager/pileOccupation/ccupyPileArchiving.vue